<script>
    import SubPageHeader from '../components/SubPageHeader.svelte'
    import { translations, current_lang } from '../stores.js';
    import {push} from 'svelte-spa-router';

    let lang_value;
    current_lang.subscribe(value => {
        lang_value = value;
    });
	function set_current_lang(lang) {
        current_lang.set(lang);
    }
    if(lang_value == undefined){
        set_current_lang("FI");
    }

    function show_installation_instructions(){
        push("/instructions/");
    }
</script>
<SubPageHeader page_title={$translations["SETTINGS"][$current_lang]} is_section_main_page={true}/>
<div class="content-container">
    <div class="settings-section">
    <h3>{$translations["LANGUAGE"][$current_lang]}</h3>
    <ul class="setting-menu">
        <li class="{$current_lang === 'FI' ? 'active' : ''}" on:click={() => set_current_lang("FI")}>Suomi</li>
        <li class="{$current_lang === 'EN' ? 'active' : ''}" on:click={() => set_current_lang("EN")}>English</li>
    </ul>
    </div>

    <div class="settings-section">
        <h3>{$translations["INSTALLATION"][$current_lang]}</h3>
        <div class="simplebutton" on:click={show_installation_instructions}>{$translations["SHOW_INSTALLATION_INSTRUCTIONS"][$current_lang]}</div>
    </div>
</div>
<style>
    .setting-menu{
        list-style-type: none;
        padding: 0;
        margin: 0;
    }
    .setting-menu li{
        padding: 5px;
        background: #fff;
        font-family: 'futura-pt', Arial;
		color: #000;
		font-weight: 700;
		text-decoration: none;
		text-transform: none;
        font-size: 1.0rem;
        display: inline-flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 75px;
        box-sizing: border-box;

        border-radius: 2px;
    }
    .setting-menu li.active{
        border: 2px solid var(--semi-dark-color)
    }
    .setting-menu li:not(:first-of-type){
        margin-left: 15px;
    }
    .settings-section{
        margin-bottom: 30px;
    }

    .settings-section h3{
        margin-bottom: 15px;
    }
</style>